import { checkVisible } from "../utils/visibility";

export function registerVideos() {
  const videos = document.getElementsByClassName("meme-video");
  for (let video of videos) {
    let width = window.innerWidth > 750 ? 608 : window.innerWidth;
    let aspectRatio = parseFloat(video.dataset.aspect);

    video.style.minHeight = `${width / aspectRatio}px`;

    video.onload = () => {
      video.classList.remove("image-loading");
    };
  }
}

//  pause videos that are out of view
export function pauseVideos() {
  const videos = document.getElementsByClassName("meme-video");
  for (let video of videos) {
    try {
      if (!checkVisible(video)) {
        video.pause();
      } else if (!video.playing && checkVisible(video)) {
        video.play();
      }
    } catch (e) {}
  }
}
